import React, { useRef, useState } from 'react';
import SbEditable from 'storyblok-react';
import GetTeam from 'src/utils/GetTeam';
import Heading from 'src/components/Heading';
import RichText from 'src/utils/RichText';
import FluidImage from 'src/utils/FluidImage';
import CustomBreadcrumbs from 'src/utils/CustomBreadcrumbs';
import PlayButton from 'src/images/play_button_meet_team.svg';

const WithLargeImages = ({ blok }) => {
    const vidRef = useRef();

    const [currentVideoIndex, setCurrentVideoIndex] = useState(null);

 let allVideoID = [];
    const handlePlayVideo = (index, videoID) => {
        setCurrentVideoIndex(index);
        const vid = document.getElementById(videoID);
        vid.play(); 
       
        allVideoID.length>0&&allVideoID.forEach((item, index) => {
            if ("video-" +item !== videoID) {
                const vidd = document.getElementById("video-" +item);
                if (vid && !vidd.paused) {
                    vidd.pause()
                    return;
                }
            }
        });
        

    };
    const finalSortedTeam = [
        ...blok.order
          .sort((a, b) => a.Number - b.Number)
          .map(({ Name }) => GetTeam().find((item) => item.name === Name) || { name: Name}),
        ...GetTeam().filter(item => !blok.order.map(({ Name }) => Name).includes(item.name))
      ];
    return (
        <SbEditable content={blok} key={blok._uid}>
            <div className={`bg-white`}>
                <div className="max-w-7xl mx-auto px-6 lg:my-40 md:32 my-16">
                    <CustomBreadcrumbs className="mb-6 mx-auto text-center" />
                    <Heading size="h1" className="text-darkblue max-w-3xl text-center mx-auto">{blok.title}</Heading>
                    <div className="max-w-xl mx-auto text-center prose text-darkblue mt-6">
                        <RichText>{blok.description}</RichText>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-14 lg:mt-20 mt-12">
                        {finalSortedTeam.map((item, index) =>
                            { 
                             item.content.video?.filename&& allVideoID.push(index)
                            return(

                            <div className="flex flex-col justify-between items-start" key={index}>
                                <div>
                                    {item.content.video?.filename ? (
                                        <div>
                                            <div className="relative max-w-7xl mx-auto">
                                                <div className="rounded-md shadow-md mb-6 w-full object-cover" style={{ height: "36rem" }}>
                                                    <video
                                                        src={item.content.video?.filename}
                                                        id={"video-" + index}
                                                        type="video/mp4"
                                                        preload="auto"
                                                        controls
                                                        width="1920"
                                                        height="1080"
                                                        muted
                                                        controlsList="nodownload"
                                                        ref={vidRef}
                                                        className="rounded-xl z-10 block w-full h-full object-cover not-prose"
                                                    >
                                                        Sorry, your browser doesn't support embedded videos.
                                                    </video>
                                                </div>
                                                <div
                                                    onClick={() => handlePlayVideo(index, "video-" + index)}
                                                    className={`rounded-xl absolute block z-10 top-0 left-0 w-full h-full object-cover cursor-pointer transition-all duration-500 ease-in-out focus:outline-none outline-none ${currentVideoIndex !== index ? "opacity-100 visible" : "opacity-0 invisible"
                                                        }`}
                                                    role="button"
                                                    tabIndex="0"
                                                >
                                                    <FluidImage
                                                        className="rounded-xl z-10 block w-full h-full object-cover not-prose"
                                                        image={item.content.image}
                                                    />
                                                    <div
                                                        className={`absolute z-20 top-[85%] left-[20%]  transform -translate-x-1/2 -translate-y-1/2 sm:h-20 h-12 sm:w-20 w-12 rounded-full inset-0 text-white opacity-30`}
                                                    >
                                                        <PlayButton className="w-full h-full" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <FluidImage
                                            image={item.content.image}
                                            className="rounded-md shadow-md mb-6 w-full object-cover"
                                        />
                                    )}
                                    <Heading size="h7" className="text-darkblue !font-semibold">{item.name}</Heading>
                                    <span className="text-brightgreen text-base block tracking-[-0.02em]">{item.content.position}</span>
                                    <div className="prose text-darkblue-700 text-sm mt-3">
                                        <RichText>{item.content.description}</RichText>
                                    </div>
                                </div>
                                <div className="mt-6 flex flex-row gap-3 text-brightgreen">
                                    {item.content.twitter && (
                                        <a href={item.content.twitter} className="group" target="_blank" rel="noreferrer">
                                            <i className="fa-brands fa-twitter text-xl group-hover:text-darkblue duration-300"></i>
                                        </a>
                                    )}
                                    {item.content.linkedin && (
                                        <a href={item.content.linkedin} className="group" target="_blank" rel="noreferrer">
                                            <i className="fa-brands fa-linkedin text-xl group-hover:text-darkblue duration-300"></i>
                                        </a>
                                    )}
                                </div>
                            </div>
                        )})}
                    </div>
                </div>
            </div>
        </SbEditable>
    );
};

export default WithLargeImages;
